<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ChangXianZhongJu`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.99941 17C2.95955 17 1.86283 16.1057 2.11396 14.8149C2.77609 11.4113 6.15202 9 9.99991 9C13.8478 9 17.2237 11.4113 17.8859 14.8149C18.137 16.1057 17.0403 17 16.0004 17H3.99941ZM16.0004 16C16.5527 16 17.0097 15.548 16.9043 15.0058C16.3516 12.1653 13.4708 10 9.99991 10C6.52903 10 3.64817 12.1653 3.09555 15.0058C2.99009 15.548 3.44712 16 3.99941 16H16.0004Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.7328 17C11.3865 17.5986 10.7393 18 10.0001 18 9.26088 18 8.6136 17.5986 8.26733 17H11.7328zM12.0004 16C12.5527 16 13.0164 16.46 12.8357 16.9819 12.429 18.1565 11.313 19 10.0001 19 8.6871 19 7.57112 18.1565 7.16444 16.9819 6.98376 16.46 7.44748 16 7.99977 16H12.0004zM10 .5C10.2761.5 10.5.723858 10.5 1V9C10.5 9.27614 10.2761 9.5 10 9.5 9.72386 9.5 9.5 9.27614 9.5 9V1C9.5.723858 9.72386.5 10 .5z"/></svg>
</template>
<script>

export default {
  name: 'IconChangXianZhongJu',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
